import { useState } from "react";

import { useRouter } from "next/router";

export const usePinnedPageProps = <TPageProps>(pageProps: TPageProps): TPageProps => {
  const routePath = useRouter().asPath.split(/[?#]/)[0];
  const [pinned, setPinned] = useState({ routePath, pageProps });

  if (pinned.routePath !== routePath) {
    setPinned({ routePath, pageProps });

    return pageProps;
  }

  return pinned.pageProps;
};
